import React from "react";
import CalendarView from "./components/calendarview/calendarView";

export default function CalendarViewApp() {
  return (
    <div>
      <h1>Calendar View Attendace</h1>
      <CalendarView />
    </div>
  );
}
